import { NotificationReward, RewardType } from './rewards.types';

export const parseRewards = (rewards: NotificationReward[]) =>
  rewards.map((reward) => {
    if (`${reward.rewardType}` === 'Free Spins') {
      return {
        ...reward,
        rewardType: RewardType.FreeSpins,
      };
    }

    return reward;
  });
